export default "__VITE_ASSET__CvjyIea1__"